import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { isMsalFlowEnabled } from 'owa-msaljs/lib/isMsalFlowEnabled';

export const isMsalEnabled = (): boolean => {
    if (isMiniHostAppFeatureEnabled('msalTokenFetch') && isMsalFlowEnabled()) {
        return true;
    }
    return false;
};
